package one.healthium.ui.common.vm

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.collect
import kotlinx.coroutines.launch

abstract class BaseViewModel : ViewModel() {
    private val scope = CoroutineScope(Dispatchers.Default + SupervisorJob())

    fun <T> Flow<T>.launch(): Job {
        return viewModelScope.launch(Dispatchers.Default) {
            collect()
        }
    }

    fun launch(block: suspend CoroutineScope.() -> Unit): Job {
        return viewModelScope.launch(Dispatchers.Default, block = block)
    }

    fun launchGlobal(block: suspend CoroutineScope.() -> Unit): Job {
        return scope.launch(Dispatchers.Default, block = block)
    }
}